import React from 'react';
import { AlertMessage, type AlertMessageVariant } from '@allygpo/ally-ux';

export type NoteTone = 'warning' | 'error' | 'success' | 'info';

interface NoteProps {
  tone?: NoteTone;
  /** Short bold lead line. */
  title?: React.ReactNode;
  children?: React.ReactNode;
  /** Controls under the text, e.g. a retry button. */
  action?: React.ReactNode;
  /** Shows a close button; the parent hides the note. */
  onClose?: () => void;
  className?: string;
}

const VARIANT: Record<NoteTone, AlertMessageVariant> = { warning: 'warn', error: 'error', success: 'success', info: 'info' };

/** Inline note: Ally UX's AlertMessage with an optional bold title line and actions underneath. */
const Note: React.FC<NoteProps> = ({ tone = 'warning', title, children, action, onClose, className }) => (
  <AlertMessage isVisible variant={VARIANT[tone]} role={tone === 'error' ? 'alert' : 'status'} onClose={onClose} closeAriaLabel="Dismiss" className={className}>
    <div className="flex flex-column">
      {title && <span className="font-semibold">{title}</span>}
      {children && <span>{children}</span>}
      {action && <div className="flex flex-wrap u-gap-2 u-mt-2">{action}</div>}
    </div>
  </AlertMessage>
);

export default Note;
